import { appAssetsCdnUrl } from '~/constants/environment';
import optimizeImage, { type Options } from '~/utilities/optimizeImage';

export const imageUrl = (filename: string, options: Options = {}) =>
  optimizeImage(
    `${appAssetsCdnUrl}/images/vending-machine/${filename}`,
    options
  );
